import * as React from 'react';
import { DataGrid} from '@mui/x-data-grid';

export default function AllCampaignTable({data, columns, componentStyle,GridToolbar,tableLoading }) {




  const cellClassName = (params) => {
    return `font-custom uppercase`;
  };



  const headerClassName = (params) => {
    return `bg-skin-table-header font-heading text-lg font-bold uppercase` // Use Tailwind CSS utility classes
  };
  return (
    <div style={componentStyle?componentStyle:{ height: 400,width: '100%'   }} className=' rounded-sm bg-skin-table-row max-sm:w-full sm:w-1/2 drop-shadow-md opacity-95 shadow-lg'>
      <DataGrid
        rows={data?data:[]}
        loading={tableLoading}

        columns={columns.map((column) => ({
            ...column,
            cellClassName: cellClassName, 
            headerClassName: headerClassName// Apply custom cell class
          }))}
        getRowId={(row) => row.repName}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10,100]}
        
        padding={2}
        disableColumnMenu={true}
        slots={{ toolbar: GridToolbar }}
        
       
      />
    </div>
  );
}
